export const QUESTION_TYPE = {
  open: 0,
  closed: 1
};

export const QUESTION_STATUS = {
  0: 'Open',
  1: 'Closed'
};
